// src/utils/roles.js

export const ROLE_PERMISSIONS = {
  NoAccess: [],

  // Available to all authenticated users
  ReadOnly: [
    'shipping-read',
    'location-read',
    'project-read',
  ],

  // Available to Stress employeers (members of SANUsers)
  Employee: [
    'shipping-read',
    'location-create',
    'location-read',
    'project-read',
  ],

  // Standard User Permissions (Can view & create certain items, but no admin access)
  User: [
    'shipping-create',
    'shipping-read',
    'shipping-update',
    'location-create',
    'location-read',
    'location-update',
    'document-create',
    'project-read',
  ],

  // Admin Permissions (Full access including edits and admin tools)
  Admin: [
    'shipping-create',
    'shipping-read',
    'shipping-update',
    'shipping-delete',
    'location-create',
    'location-read',
    'location-update',
    'document-create',
    'project-read',

    'admin-tools',
    'manage-users',         // Can manage user roles and access
    'manage-settings',      // Can access global settings
  ],

  // Developer Permissions (Admin permissions plus in-development features)
  Dev: [
    'shipping-create',
    'shipping-read',
    'shipping-update',
    'shipping-delete',
    'location-create',
    'location-read',
    'location-update',
    'document-create',
    'project-read',

    'admin-tools',
    'manage-users',         // Can manage user roles and access
    'manage-settings',      // Can access global settings

    'calibration-read',
    'calibration-update'
  ]
};



// Helper function to check if a role has access to a route
export const hasRoleAccess = (userRole, requiredPermission) => {
  return ROLE_PERMISSIONS[userRole]?.includes(requiredPermission) || false;
};

